// Status keys are stable; labels are localized via t(). Badge class controls visual.
// `saved` = user parked a job but hasn't applied yet (still researching / prepping).
// `clarification` = employer asked the candidate for extra info/toelichting —
//   flagged as a distinct workflow state so the user can see at a glance
//   which applications are stuck waiting on their reply.
// `hired` = candidate was actually offered/accepted the role — end-of-funnel
//   celebration state. Kept OUT of the "active" filters so hired roles
//   drop off the working overview but stay in archive/history.
export const STATUS_KEYS = ["saved", "applied", "invited", "clarification", "hired", "rejected"];
export const CHANNEL_KEYS = ["linkedin", "recruiter", "open"];
export const JOB_TYPE_KEYS = ["incompany", "freelance", "outsourced"];
export const RATE_TYPE_KEYS = ["hourly", "daily", "monthly"];

export const statusBadgeClass = {
  saved: "badge-saved",
  applied: "badge-applied",
  invited: "badge-invited",
  clarification: "badge-clarification",
  hired: "badge-hired",
  rejected: "badge-rejected",
};

export function statusLabelKey(value) {
  if (value === "saved") return "savedStatus";
  if (value === "invited") return "invitedStatus";
  if (value === "clarification") return "clarificationStatus";
  if (value === "hired") return "hiredStatus";
  if (value === "rejected") return "rejectedStatus";
  return "appliedStatus";
}

export function channelLabelKey(value) {
  if (value === "recruiter") return "channelRecruiter";
  if (value === "open") return "channelOpen";
  return "channelLinkedIn";
}

export function jobTypeLabelKey(value) {
  if (value === "freelance") return "typeFreelance";
  if (value === "outsourced") return "typeOutsourced";
  return "typeIncompany";
}

// Short abbreviated labels for dashboard table (same in both languages)
export function jobTypeShortLabel(value) {
  if (value === "freelance") return "ZZP";
  if (value === "outsourced") return "DET";
  return "Dienst";
}

export function rateTypeLabelKey(value) {
  if (value === "daily") return "rateDaily";
  if (value === "monthly") return "rateMonthly";
  return "rateHourly";
}

export function formatDate(iso, lang) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    const locale = lang === "en" ? "en-GB" : "nl-NL";
    return d.toLocaleDateString(locale, { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}
